import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loginRequest } from "../../service/authService";
import { toast } from "react-toastify";

export const initialState = {
  data: {},
};

export const signIn = createAsyncThunk(
  "auth/signIn",
  async (data, { rejectWithValue }) => {
    const { email, password, timeZoneData } = data;
    try {
      const response = await loginRequest({ email, password, timeZoneData });
      if (response) {
        const { accessToken, refreshToken, message } = response.data;
        localStorage.setItem("auth_token", accessToken);
        if (
          refreshToken &&
          typeof refreshToken === "string" &&
          refreshToken !== "undefined" &&
          refreshToken !== "null"
        ) {
          localStorage.setItem("refreshToken", refreshToken);
        } else {
          localStorage.removeItem("refreshToken");
        }
        if (response.status === 200) {
          toast.success(message, { autoClose: 5000 });
          return accessToken;
        } else {
          return rejectWithValue(message);
        }
      } else {
        return rejectWithValue(response?.data?.message);
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { setAuthData } = authSlice.actions;
export default authSlice.reducer;
